import React from 'react';
import { useTranslation } from 'react-i18next';

import { MicOffIcon, MicOnIcon } from '@icons';

import HomeBarButton from '@core/dashboard/components/HomeBarButton';
import WarningButtonBadge from '@core/dashboard/components/WarningButtonBadge';

import {
  getErrorNotification,
  useNotification,
} from '@components/Notification';
import { sendCustomSentryBreadcrumb } from '@helpers/sentry';
import { useIsSpeakerMutedNotificationShown } from '@core/dashboard/components/DashboardContent/Dolby/hooks';

import { useMytaverseEvent } from '@core/dashboard/providers';
import { useCommunications } from '@core/communications/providers/CommunicationsProvider';
import { useConference } from '@core/dashboard/components/DashboardContent/Dolby';
import { AnalyticsType } from '@interfaces/analytics';
import { useClientSpecificDashboardButtonDisabled } from '@hooks/clientSpecificUtils';
import { DashboardButtonEnum } from '@constants/dashboard';

const MicButton = () => {
  const { isConferenceInitialized, isConferenceListener } = useConference();

  const { muted, setMuted, trackEventAnalytics } = useMytaverseEvent();

  const isDisabledClientSpecific = useClientSpecificDashboardButtonDisabled(
    DashboardButtonEnum.MIC_BUTTON,
  );

  const { isInConference, micList, isMicrophonePermissionGranted } =
    useCommunications();

  const { showNotification } = useNotification();

  const { speakerMutedNotification, resetSpeakerMutedNotification, showPulse } =
    useIsSpeakerMutedNotificationShown(isConferenceInitialized, muted);
  const { t: translate } = useTranslation();

  const microDeviceId = micList.length ? micList[0].deviceId : '';

  const handleMicroClick = () => {
    trackEventAnalytics(AnalyticsType.NavbarButtonClick, { name: 'mic' });

    if (!microDeviceId) {
      showNotification(
        getErrorNotification({
          message: translate(
            'notifications.microphone.start.userForbiddenCapture',
          ),
        }),
      );
    } else {
      sendCustomSentryBreadcrumb({
        message: `${!muted ? 'mute' : 'unmute'} micro`,
      });
      setMuted();
      resetSpeakerMutedNotification(speakerMutedNotification);
    }
  };

  const translatedMicTooltip =
    microDeviceId || isMicrophonePermissionGranted
      ? 'tooltips.toggleMic'
      : 'tooltips.warningPermissionCam';

  return (
    <HomeBarButton
      label={translate(translatedMicTooltip)}
      handleClick={handleMicroClick}
      isActive={!muted}
      //showPulseAnimation={!!showPulse}
      //isRed={muted || !microDeviceId}
      disabled={
        !isInConference ||
        isConferenceListener ||
        !microDeviceId ||
        isDisabledClientSpecific
      }
      icon={
        <>
          {muted || !isMicrophonePermissionGranted ? (
            <WarningButtonBadge isHidden={isMicrophonePermissionGranted}>
              <MicOffIcon />
            </WarningButtonBadge>
          ) : (
            <MicOnIcon />
          )}
        </>
      }
    />
  );
};

export default MicButton;
